import { render, staticRenderFns } from "./CrmTemplateList.vue?vue&type=template&id=3607a559&scoped=true"
import script from "./CrmTemplateList.vue?vue&type=script&lang=ts"
export * from "./CrmTemplateList.vue?vue&type=script&lang=ts"
import style0 from "./CrmTemplateList.vue?vue&type=style&index=0&id=3607a559&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3607a559",
  null
  
)

export default component.exports